import module from 'fanconsultores/module.js'
import template from './template.html'

class FanconsultoresAdminDashboardContabilidadComponent {
  constructor(AdminDashboard) {
    this.AdminDashboard = AdminDashboard
  }

  $onInit() {
    this.promise = this.AdminDashboard.permisosContabilidad()
      .then((data) => (this.permisos = data))
  }
}

module.component('fanconsultoresAdminDashboardContabilidad', {
  controller: FanconsultoresAdminDashboardContabilidadComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/fanconsultores/admin/dashboard/contabilidad/component.js